import { useToast } from './useToast';
import { CheckCircle, XCircle, Info, AlertTriangle, X } from 'lucide-react';

export function Toaster() {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-50 flex flex-col gap-2 max-w-md">
      {toasts.map((toast) => {
        const icons = {
          success: <CheckCircle className="w-5 h-5 text-emerald-600" />,
          error: <XCircle className="w-5 h-5 text-red-600" />,
          info: <Info className="w-5 h-5 text-blue-600" />,
          warning: <AlertTriangle className="w-5 h-5 text-yellow-600" />,
        };

        const backgrounds = {
          success: 'bg-emerald-50 border-emerald-200',
          error: 'bg-red-50 border-red-200',
          info: 'bg-blue-50 border-blue-200',
          warning: 'bg-yellow-50 border-yellow-200',
        };

        return (
          <div
            key={toast.id}
            className={`${backgrounds[toast.type]} border rounded-lg shadow-lg p-4 min-w-[300px] animate-in slide-in-from-right`}
          >
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0">{icons[toast.type]}</div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900">{toast.title}</p>
                {toast.message && (
                  <p className="mt-1 text-sm text-gray-600">{toast.message}</p>
                )}
              </div>
              <button
                onClick={() => removeToast(toast.id)}
                className="flex-shrink-0 text-gray-400 hover:text-gray-600"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
